<div class="exit-dialog">
  <h2>{{ 'exitTest.title' | translate }}</h2>
  <mat-dialog-content class="exit-dialog__content">
    {{ 'exitTest.message' | translate }}
  </mat-dialog-content>
  <mat-dialog-actions class="exit-dialog__actions">
    <button
      type="button"
      mat-flat-button
      color="primary"
      cdkFocusInitial
      (click)="dialogRef.close(false)"
    >
      {{ 'exitTest.stay' | translate }}
    </button>
    <!-- F20 (Danna 09.09): exactly two choices, and leaving is NOT a delete
         action - no warn colour, no "discard" wording. The copy carries the
         consequence: leaving does not save the progress. -->
    <button
      type="button"
      mat-stroked-button
      (click)="dialogRef.close(true)"
    >
      {{ 'exitTest.leave' | translate }}
    </button>
  </mat-dialog-actions>
</div>
